import type { ReactElement } from "react";

import { translate } from "app/filters/i18nFilter";
import { FormFieldLabel } from "app/pages/sales-intelligence/common-components/form-fields";

import type FindRangeSelectFilter from "../../../models/RangeSelectFilter/RangeSelectFilter";
import type { IFilterViewBaseProps } from "../../../types/filterInstance";
import { FilterContentContainer } from "../../styles";

import RangeSelectWithClear from "./RangeSelectWithClear";

const RangeSelectFilter = ({
    filter: {
        options: { fieldName, labelKey, buckets, placeholderPrefix, formatValue },
    },
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<FindRangeSelectFilter>): ReactElement | null => {
    const handleChange = ([minValue, maxValue]: readonly number[]) => {
        onFilterUpdate({
            from: minValue,
            to: maxValue,
        });
    };

    const clearSelection = () => onFilterUpdate();

    const content = (
        <RangeSelectWithClear
            fieldName={fieldName}
            value={value}
            buckets={buckets}
            formatValue={formatValue}
            placeholderPrefix={placeholderPrefix}
            onChange={handleChange}
            onClear={clearSelection}
        />
    );

    return (
        <FilterContentContainer>
            {labelKey ? <FormFieldLabel text={translate(labelKey)}>{content}</FormFieldLabel> : content}
        </FilterContentContainer>
    );
};

export default RangeSelectFilter;
